// src/components/SupportOpportunity.js
import React from "react";
import styled from "styled-components";
import ContactForm from "./forms/ContactForm"; // Ensure correct import path

const SupportOpportunity = ({
  title,
  image,
  description,
  waysToSupport,
  formTitle,
  formDirections,
  thankYouMessage,
}) => {
  return (
    <Container>
      <h1>{title}</h1>
      <ImageWrapper>
        <img src={image} alt={title} />
      </ImageWrapper>
      <Section>
        <h2>Details</h2>
        <p>{description}</p>
      </Section>
      <Section>
        <h2>Ways to Support</h2>
        <SupportList>
          {waysToSupport.map((way, index) => (
            <li key={index}>{way}</li>
          ))}
        </SupportList>
      </Section>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
`;

const ImageWrapper = styled.div`
  margin-bottom: 20px;
  img {
    width: 100%;
    border-radius: 8px;
  }
`;

const Section = styled.div`
  margin-top: 40px;
  text-align: left;

  h2 {
    color: var(--hhb-primary);
  }

  p {
    line-height: 1.6;
  }
`;

const SupportList = styled.ul`
  list-style-type: disc;
  padding-left: 20px;

  li {
    margin-bottom: 10px;
  }
`;

export default SupportOpportunity;
